// External Dependencies
import { useCallback } from 'react';
import FileCopy from '@mui/icons-material/FileCopy';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

// Local Typings
interface Props {
  textToCopy: string;
  tooltipTitle: string;
}

// Component Definition
const CopyToClipboardButton = ({
  textToCopy,
  tooltipTitle,
}: Props): JSX.Element => {
  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(textToCopy);
  }, [textToCopy]);

  return (
    <Tooltip title={tooltipTitle}>
      <IconButton
        onClick={handleCopy}
        size="large"
      >
        <FileCopy />
      </IconButton>
    </Tooltip>
  );
};

export default CopyToClipboardButton;
